import { useState, useEffect } from "react";
import { Mail, Phone } from "lucide-react";
import { getCurrentStudio } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const [currentStudio, setCurrentStudio] = useState(getCurrentStudio());

  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentStudio(getCurrentStudio());
    };

    window.addEventListener("studioUpdated", handleStorageChange);

    return () => {
      window.removeEventListener("studioUpdated", handleStorageChange);
    };
  }, []);

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-center md:text-left">
          {currentStudio?.name && (
            <h3 className="text-lg font-semibold text-gray-800">{currentStudio.name}</h3>
          )}

          {currentStudio?.email && (
            <a
              href={`mailto:${currentStudio.email}`}
              className="flex items-center text-primary hover:text-secondary transition-colors"
            >
              <Mail className="w-5 h-5 mr-2" />
              {currentStudio.email}
            </a>
          )}

          {currentStudio?.phone && (
            <a
              href={`tel:${currentStudio.phone}`}
              className="flex items-center text-primary hover:text-secondary transition-colors"
            >
              <Phone className="w-5 h-5 mr-2" />
              {currentStudio.phone}
            </a>
          )}
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mt-8">
          <a
            href="/terms/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {t('terms.title')}
          </a>
          <a
            href="/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {t('privacy.title')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;